import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { interpolateString, get, shapedPropsWarning } from 'ctm-util-functions';
import { Text } from '../text/text';

const _TextTemplate = (props) => {
    // @todo remove once all shapedProps are gone
    shapedPropsWarning(props, 'TextTemplate');
    const { className, textProps } = props;

    /**
     * Continue rendering the Text component
     * @returns {Text} Text Component
     */
    return <Text className={className} {...textProps} />;
};

_TextTemplate.propTypes = {
    label: PropTypes.string,
    innerHTML: PropTypes.string,
    stateKey: PropTypes.string, // set default state tree start level before parsing the template
    className: PropTypes.string,
    textProps: PropTypes.object
};

/**
 * Return an interpolated version of the template.
 * @param {Object} props The content props passed from schema
 * @param {Object} state The state object.
 * @returns {String} The interpolated string
 */
const parseTemplate = (props, state) => {
    return interpolateString(props.label || props.innerHTML || '')(state);
};

/**
 * Map the application state to ozur component's local props
 * @param {Object} state - the application's state / store
 * @param {Object} props - this component's local props
 * @returns {{textProps: object}} state - the updated props
 */
const mapStateToProps = (state, props) => {
    // we need to do a deep copy here otherwise the template gets replaced with the interpolated string and won't update
    // unless the TextTemplate is remounted.
    // This component needs to be refactored so that this isn't necessary, we should NOT be mutating values that are already on props
    // @todo: see EVT-1784 for details on cleaning this up
    const textProps = JSON.parse(JSON.stringify(props));

    const cpKey = props.innerHTML ? 'innerHTML' : 'label';

    let subState = {};

    if (props.selectedValues) {
        subState = props.selectedValues;
    } else if (props.resolvedStateProps) {
        subState = props.resolvedStateProps;
    } else if (props.stateProps) {
        subState = Object.keys(props.stateProps).reduce((acc, key) => {
            acc[key] = state.getIn(props.stateProps[key].split('.'));
            return acc;
        }, {});
    } else {
        subState = get(state, props.stateKey || 'vertical');
    }
    textProps[cpKey] = parseTemplate(props, subState);

    // We don't want to pass stateKey to text component as it will overwrite the text prepared in this component
    delete textProps.stateKey;
    return {
        textProps
    };
};

const TextTemplate = connect(mapStateToProps)(_TextTemplate);
export { TextTemplate };
